// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1anNN","colMaxWidth":"Table_colMaxWidth__2gsRV"};